/* globals Knitiv */

export default class {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 */
	constructor($rootScope, $sce) {
		const token = $rootScope.context?.token.id;
		const endpoint = $rootScope.context?.url?.back;

		this.src = $sce.trustAsResourceUrl(
			`https://v5.dev03.knitiv.net/admin/class-designer?token=${token}&endpoint=${endpoint}&from=4`,
		);
	}
}
